// extracted by mini-css-extract-plugin
module.exports = {"wrapperInput":"index_wrapperInput__r9eqT","wrapperButtons":"index_wrapperButtons__3WY-s"};